import type { ScriptWord } from "../types";

/** Both rehearsal entry points start at the selected prompt word and skip cues. */
export function rehearsalTextFrom(words: readonly ScriptWord[], wordIndex: number): string {
  return words
    .filter((word) => !word.cue && word.index >= wordIndex)
    .map((word) => word.text)
    .join(" ");
}
